import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faStar,
  faUsers,
  faComments,
  faList,
  faSearch,
  faBars,
  faTimes,
  faAlignLeft,
  faAlignRight,
  faCrown,
  faBox,
  faCog,
  faLayerGroup,
  faCogs,
  faTasks,
  faFileAlt,
  faPlay,
  faPause,
  faSyncAlt,
  faHistory,
  faClock,
  faSpinner,
  faCheckCircle,
  faInbox,
  faBullhorn,
  faPhotoFilm,
  faEnvelope,
  faBook,
  faBookOpen,
  faHeadphones,
  faLink,
  faSpellCheck,
  faGift,
  faSlidersH,
  faCoins,
  faMoneyBillWave,
  faTicket,
  faBuilding,
  faMobileScreen,
  faCodeBranch,
  faCloudUploadAlt
} from '@fortawesome/free-solid-svg-icons'

// Add icons to library
library.add(
  faStar,
  faUsers,
  faComments,
  faList,
  faSearch,
  faBars,
  faTimes,
  faAlignLeft,
  faAlignRight,
  faCrown,
  faBox,
  faCog,
  faLayerGroup,
  faCogs,
  faTasks,
  faFileAlt,
  faPlay,
  faPause,
  faSyncAlt,
  faHistory,
  faClock,
  faSpinner,
  faCheckCircle,
  faInbox,
  faPhotoFilm,
  faBullhorn,
  faEnvelope,
  faBook,
  faBookOpen,
  faHeadphones,
  faLink,
  faSpellCheck,
  faGift,
  faSlidersH,
  faCoins,
  faMoneyBillWave,
  faTicket,
  faBuilding,
  faMobileScreen,
  faCodeBranch,
  faCloudUploadAlt
)

export { FontAwesomeIcon }
